import { Style, Fill, Stroke, Circle } from 'ol/style'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
const style = new Style({
  fill: new Fill({
    color: 'rgba(255, 52, 219, 0.2)'
  }),
  stroke: new Stroke({
    color: 'rgba(255, 52, 219, 0.85)',
    width: 2
  }),
  image: new Circle({
    radius: 4,
    fill: new Fill({
      color: 'rgba(255, 52, 219, 0.2)'
    }),
    stroke: new Stroke({
      color: 'rgba(255, 52, 219, 0.85)',
      width: 2
    })
  })
})

export default new VectorLayer({
  name: 'draw',
  source: new VectorSource({}),
  style: style
})
